/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopOrderDto } from '../../models/shop-order-dto';
import { UserInfoDto } from '../../models/user-info-dto';

export interface ShopGetShopOrders$Params {
  'x-trace-id'?: string;
      body: UserInfoDto
}

export function shopGetShopOrders(http: HttpClient, rootUrl: string, params: ShopGetShopOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShopOrderDto>>> {
  const rb = new RequestBuilder(rootUrl, shopGetShopOrders.PATH, 'post');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ShopOrderDto>>;
    })
  );
}

shopGetShopOrders.PATH = '/api/shop/shop-orders';
